import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatCurrency, parseCurrency } from 'utils/i18n';

import ColumnClassNamesType from 'propTypes/columnClassNamesType';

const CurrencyCell = (props) => {
  const { contact, value, columnClassNames, defaultToZero } = props;
  const defaultValue = defaultToZero ? formatCurrency(0) : NaN;
  const match = value.match(/^(.*?)__(.*?)$/);
  let result;

  if (match && match[1] && match[2]) {
    result = contact[match[1]][match[2]] != null ? formatCurrency(contact[match[1]][match[2]]) : defaultValue;
  } else {
    result = contact[value] != null ? formatCurrency(contact[value]) : defaultValue;
  }

  const parsedResult = parseCurrency(result);
  const className = classNames(
    'contact-list-react-type-currency',
    columnClassNames,
    {'negative-number': !Number.isNaN(parsedResult) && parsedResult < 0}
  );

  return (
    <td className={className}>
      {!Number.isNaN(parsedResult) ? result : ''}
    </td>
  );
};

CurrencyCell.propTypes = {
  contact: PropTypes.shape({
    id: PropTypes.string
  }),
  value: PropTypes.string,
  columnClassNames: ColumnClassNamesType,

  /* Whether to default to $0 instead of NaN/empty cell */
  defaultToZero: PropTypes.bool
};

CurrencyCell.defaultProps = {
  columnClassNames: '',
  contact: {},
  value: '',
  defaultToZero: false
};

export default CurrencyCell;
